import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

import applicationReducer from './reducers/applicationReducer';
import authReducer from 'shared/reducers/auth';
import phoneConfirmReducer from 'shared/reducers/phoneConfirmReducer';
import joinReducer from './reducers/joinReducer';
import createPasswordReducer from 'shared/reducers/createPasswordReducer';
import balanceReducer from 'shared/reducers/balance';
import passwordRecoveryReducer from './reducers/passwordRecoveryReducer';
import betGamesReducer from './reducers/betGamesReducer';
import gamesReducer from './reducers/gamesReducer.js';
import domainReducer from 'shared/reducers/domainReducer';
import promoCodeReducer from 'shared/reducers/promoCodeReducer';

const reducer = combineReducers({
    routing: routerReducer,
    form: formReducer,
    application: applicationReducer,
    auth: authReducer,
    phoneConfirm: phoneConfirmReducer,
    join: joinReducer,
    createPassword: createPasswordReducer,
    balance: balanceReducer,
    passwordRecovery: passwordRecoveryReducer,
    domain: domainReducer,
    betGames: betGamesReducer,
    games: gamesReducer,
    promoCode: promoCodeReducer
});

export default reducer;


// WEBPACK FOOTER //
// ./js/sport-betting/rootReducer.js